import { createFileRoute } from "@tanstack/react-router"
import DesignSystemViewPill from "~/pages/design-system/components/ViewPill"

export const Route = createFileRoute("/_auth/internal/design-system/components/view-pill")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemViewPill />
}
